export default __webpack_public_path__ + "static/media/ICE_2.20246bfd.png";